'use strict';

function pair(param1, param2) {
    return (p1, p2) => {
        return {
            [param1]: p1,
            [param2]: p2
        };
    };
}

module.exports = pair;



// WEBPACK FOOTER //
// ./src/lib/ucp/utils/pair.js